/**
 * Wishlist — localStorage tabanlı favori listesi (ürün sayfası, quick-add, wishlist sayfası, header sayacı).
 */
(function () {
  const WISHLIST_SVG_FILLED =
    '<svg class="heart-filled" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="currentColor"/></svg>';
  const WISHLIST_SVG_OUTLINE =
    '<svg class="heart-outline" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/></svg>';

  function setWishlistButtonState(button, isInWishlist) {
    if (!button) return;

    const iconEl = button.querySelector('[data-wishlist-icon]');
    const labelEl = button.querySelector('[data-wishlist-label]');
    const svgHtml = isInWishlist ? WISHLIST_SVG_FILLED : WISHLIST_SVG_OUTLINE;
    const labelAdd = button.dataset.labelAdd || 'Favorilere ekle';
    const labelAdded = button.dataset.labelAdded || 'Eklendi';

    if (iconEl) {
      iconEl.innerHTML = svgHtml;
    } else {
      button.innerHTML = svgHtml;
    }

    if (labelEl) {
      labelEl.textContent = isInWishlist ? labelAdded : labelAdd;
    }

    button.setAttribute('aria-pressed', isInWishlist ? 'true' : 'false');
    button.setAttribute('aria-label', isInWishlist ? labelAdded : labelAdd);
  }

  function initWishlistButtons(root) {
    const scope = root || document;
    const wishlistData = JSON.parse(localStorage.getItem('wishlist') || '[]');

    scope.querySelectorAll('.product-form-wishlist-button').forEach(function (button) {
      const productTitle = button.dataset.productTitle;
      if (!productTitle) return;

      const isAlreadyInWishlist = wishlistData.some(function (item) {
        return item.productTitle === productTitle;
      });

      setWishlistButtonState(button, isAlreadyInWishlist);
    });
  }

  function syncWishlistButtonsForProduct(productTitle, isInWishlist) {
    document.querySelectorAll('.product-form-wishlist-button').forEach(function (button) {
      if (button.dataset.productTitle === productTitle) {
        setWishlistButtonState(button, isInWishlist);
      }
    });
  }

  function escapeWishlistHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getWishlistCount() {
    try {
      const wishlistData = JSON.parse(localStorage.getItem('wishlist') || '[]');
      if (!Array.isArray(wishlistData)) return 0;

      return wishlistData.filter(function (item) {
        return item && item.productTitle && item.productUrl;
      }).length;
    } catch (error) {
      return 0;
    }
  }

  function updateWishlistCount() {
    const count = getWishlistCount();

    document.querySelectorAll('[data-header-wishlist-count]').forEach(function (el) {
      el.textContent = count + ' ürün';
    });

    document.dispatchEvent(new CustomEvent('wishlist:update', { detail: { count: count } }));
  }

  function displayWishlist() {
    const wishlistData = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const wishlistBlock = document.querySelector('.js-wishlistBlock');
    const wishlistEmpty = document.querySelector('.js-wishlistEmpty');

    updateWishlistCount();

    if (!wishlistBlock) return;

    if (wishlistData.length === 0) {
      wishlistBlock.innerHTML = '';
      if (wishlistEmpty) wishlistEmpty.hidden = false;
      return;
    }

    if (wishlistEmpty) wishlistEmpty.hidden = true;

    const wishlistHtml = wishlistData
      .map(function (item) {
        const title = escapeWishlistHtml(item.productTitle);
        const url = escapeWishlistHtml(item.productUrl);
        const image = escapeWishlistHtml(item.productImg);
        const price = escapeWishlistHtml(item.productPrice);

        return (
          '<div class="resource-list__item">' +
          '<article class="ps-card" data-ps-card>' +
          '<div class="ps-card__inner">' +
          '<div class="ps-card__media">' +
          '<a class="ps-card__media-link" href="' +
          url +
          '">' +
          '<img class="ps-card__image" src="' +
          image +
          '" alt="' +
          title +
          '" loading="lazy" width="500" height="500">' +
          '</a>' +
          '<span class="ps-card__shadow" aria-hidden="true"></span>' +
          '</div>' +
          '<div class="ps-card__body">' +
          '<a class="ps-card__title-link" href="' +
          url +
          '">' +
          '<h3 class="ps-card__title">' +
          title +
          '</h3>' +
          '</a>' +
          '<div class="ps-card__footer">' +
          '<div class="ps-card__price-wrap">' +
          '<p class="ps-card__price">' +
          price +
          '</p>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '</article>' +
          '</div>'
        );
      })
      .join('');

    wishlistBlock.innerHTML = wishlistHtml;
  }

  function toggleWishlist(button, event) {
    if (event) {
      event.stopPropagation();
    }

    if (!button || !button.dataset.productTitle) return;

    const pdpData = {
      productTitle: button.dataset.productTitle,
      productImg: button.dataset.productImg,
      productPrice: button.dataset.productPrice,
      productUrl: button.dataset.productUrl,
    };

    let wishlistData = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const isAlreadyInWishlist = wishlistData.some(function (item) {
      return item.productTitle === pdpData.productTitle;
    });

    if (!isAlreadyInWishlist) {
      wishlistData.push(pdpData);
      localStorage.setItem('wishlist', JSON.stringify(wishlistData));
      syncWishlistButtonsForProduct(pdpData.productTitle, true);
    } else {
      wishlistData = wishlistData.filter(function (item) {
        return item.productTitle !== pdpData.productTitle;
      });
      localStorage.setItem('wishlist', JSON.stringify(wishlistData));
      syncWishlistButtonsForProduct(pdpData.productTitle, false);
    }

    displayWishlist();
  }

  window.initWishlistButtons = initWishlistButtons;
  window.toggleWishlist = toggleWishlist;
  window.updateWishlistCount = updateWishlistCount;

  document.addEventListener('DOMContentLoaded', function () {
    initWishlistButtons();
    displayWishlist();
    updateWishlistCount();

    window.addEventListener('storage', function (event) {
      if (event.key === 'wishlist') {
        initWishlistButtons();
        displayWishlist();
      }
    });
  });
})();
